export default {
  currentPeriod: 'Recent period',
  displacedPeriod: 'Previous period',
};
